
import axios from 'axios'
import router from '@/router'
import { message,Modal } from 'ant-design-vue'
import storage from 'store'
import NProgress from 'nprogress' // 引入nprogress插件
import 'nprogress/nprogress.css' // 这个nprogress样式必须引入
import qs from 'qs';
let stepNum = 0; // 请求计步器
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL; // 配置axios请求的地址
axios.defaults.timeout = 150000; // 请求超时时间

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// 请求拦截器
axios.interceptors.request.use(
    config => {
        let {  method,costom  } = config;
        costom = costom || {};
        // 计步器加1
        if (stepNum == 0 && !costom.hideLoading) {
            // 打开loading
            NProgress.start();
        }
        ++stepNum;

        /****************    参数处理 start   ******************/
        let requestData = method == 'get' ? 'params' : 'data';
        // 防止空对象
        !config.data && (config.data = {});
        !config.params && (config.params = {});

        /*统一加入meeting_id hall_id参数*/
        let {meeting_id,hall_id} = router.currentRoute.params;
        hall_id = config.data?.hall_id || hall_id;
        meeting_id = config.data?.meeting_id || meeting_id;

        config.data = Object.assign(config.data || {},{meeting_id,hall_id});
        if (method == 'post') {
            config.data = qs.stringify(config.data);
        }

        // 商户id
        const committeeID = storage.get('committee_id');
        // token
        const token = storage.get('auth')
        // 让每个请求携带自定义 token 请根据实际情况自行修改
        if (config.url != 'https://mm.sciconf.cn/ajax/get-weixin-jsapi') {
            if (token) {
                config.headers['auth'] = token
            }
            if(committeeID){
                config.headers['committeeID'] = committeeID
            }
        }
        
        return config
    },
    error => {
        console.log(err);
        return Promise.error(error);
    }
);


axios.interceptors.response.use(
    response => {
        let costom = response.config.costom || {}
        // 计步器减一
        --stepNum;
        if (stepNum == 0 && !costom.hideLoading) {
            // 关闭loading
            NProgress.done();
        }
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
        // 否则的话抛出错误
        if (response.status === 200) {
            // 统一处理非200提示
            let {  code,  message } = response.data
            // hideModal 如果为true则隐藏错误弹框
            if (code != 100000 && message && !costom.hideModal) {
                Modal.error({
                    title:'提示',
                    content:message,
                    okText:'确定',
                    onOk:() => {
                        costom.errorCallback && typeof(costom.errorCallback) == 'function' && costom.errorCallback(response.data)
                    }
                })
                return Promise.reject(response.data);
            }
            return Promise.resolve(response.data);
        } else {
            return Promise.reject(response.data);
        }
    },
    // 服务器状态码不是2开头的的情况
    // 这里可以跟你们的后台开发人员协商好统一的错误状态码
    // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
    // 下面列举几个常见的操作，其他需求可自行扩展
    error => {
        // 错误后关闭所有loading
        // 计步器减一
        --stepNum;
        if (stepNum == 0) {
            // 关闭loading
            NProgress.done();
        }
        if (error.response && error.response.status) {
            switch (error.response.status) {
                case 201:
                    message.error("您没有当前会议的分座权限");
                    break;
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 401:
                    // message.error("身份验证失败");
                    // 清除token
                    storage.remove('auth');
                    let href = window.location.href;
                    // 去除过多的unified
                    href = href.split('unified=');
                    href = href[0];
                    let committee_login_url = storage.get('committee_login_url');
                    window.location.href = committee_login_url+"/unified/login?return_url="+encodeURIComponent(href);
                    break;
                    // 403 token过期
                    // 登录过期对用户进行提示
                    // 清除本地token和清空vuex中token对象
                    // 跳转登录页面
                case 403:
                    message.error("登录过期，请关闭重新进入。");
                    // 清除token
                    break;

                    // 404请求不存在
                case 404:
                    message.error("您访问的网页不存在。");
                    break;

                    // 404请求不存在
                case 500:
                    message.error("数据加载出错");
                    break;
                    // 其他错误，直接抛出错误提示
                default:
                    message.error(error.response.data.message);
            }
            return Promise.reject(error.response);
        }else{
            console.log(error);
            return Promise.reject(error);
        }
    }
);
export default axios;